export const EVENT_TYPE_MEDICATION = 'Medication';
export const EVENT_TYPE_MEDICAL_APPOINTMENT = 'Medical Appointment';
export const EVENT_TYPE_SOCIAL = 'Social';
export const EVENT_TYPE_OTHER = 'Other';
export const EVENT_TYPE_AIRFORCE_DEPLOYMENT = 'Airforce Deployment';
export const EVENT_TYPE_READINESS = 'Airforce Deployment';
export const EVENT_TYPE_IMMUNIZATION = 'Immunization Appointment';
export const EVENT_TYPE_DRHA = 'DRHA Appointment';
export const EVENT_TYPE_LAB = 'Lab Appointment';
export const EVENT_TYPE_AUDIOGRAM = 'Audiogram Appointment';
export const EVENT_TYPE_PHA = 'Non-fly PHA Appointment';
export const EVENT_TYPE_PHA_FLY = 'Fly PHA Appointment';
export const EVENT_TYPE_OHE = 'OHE Appointment';
export const EVENT_TYPE_SHPE = 'SHPE Appointment';
export const EVENT_TYPE_SERE_ECAC = 'SERE-ECAC Appointment';
export const EVENT_TYPE_SPIROMETRY = 'Spirometry Appointment';
export const EVENT_TYPE_AUDIOGRAM_SPIROMETRY = 'Audiogram-Spirometry Appointment';
export const EVENT_TYPE_SECURITY_FORCES_PCM = 'Security Forces PCM Appointment';
export const EVENT_TYPE_DENTAL = 'Dental Appointment';
export const EVENT_TYPE_CMR = 'Continuous Medical Readiness Appointment';
export const EVENT_TYPE_CMR_FLY = 'Fly Continuous Medical Readiness Appointment';
export const EVENT_TYPE_IMAGING_IMPORT_PICKUP = 'Imaging Import & Pick-up Appointment';
export const EVENT_TYPE_ANAM_TEST = 'ANAM Test Appointment';
export const EVENT_TYPE_COMMUNITY_HEALTH_INTERVIEW = 'Community Health Interview Appointment';
export const EVENT_TYPE_TRAVEL_MEDICINE = 'Travel Medicine Appointment';
export const EVENT_TYPE_SPECIALTY_HEARING = 'Specialty Hearing Appointment';

export const DIRECT_APPOINTMENT_TYPES = [EVENT_TYPE_ANAM_TEST, EVENT_TYPE_IMMUNIZATION];

export const EVENT_TYPES_REQUIRING_APPROVAL = [
  EVENT_TYPE_LAB,
  EVENT_TYPE_AUDIOGRAM,
  EVENT_TYPE_PHA,
  EVENT_TYPE_PHA_FLY,
  EVENT_TYPE_OHE,
  EVENT_TYPE_SHPE,
  EVENT_TYPE_SERE_ECAC,
  EVENT_TYPE_SPIROMETRY,
  EVENT_TYPE_AUDIOGRAM_SPIROMETRY,
  EVENT_TYPE_SECURITY_FORCES_PCM,
  EVENT_TYPE_DENTAL,
  EVENT_TYPE_CMR,
  EVENT_TYPE_CMR_FLY,
  EVENT_TYPE_DRHA,
  EVENT_TYPE_IMAGING_IMPORT_PICKUP,
  EVENT_TYPE_COMMUNITY_HEALTH_INTERVIEW,
  EVENT_TYPE_TRAVEL_MEDICINE,
  EVENT_TYPE_SPECIALTY_HEARING,
];

export const APPT_TYPES = [
  ...DIRECT_APPOINTMENT_TYPES,
  ...EVENT_TYPES_REQUIRING_APPROVAL,
  EVENT_TYPE_READINESS,
];
